// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2om9T","inputWrap":"CustomTip_inputWrap__xZI8V"};